// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"35802dc8","97":"a34c6f75","546":"5937524f"}[chunkId] + ".js";
};